import React, { Component } from 'react'
import GoogleAnalytics from 'react-ga'

if (process.env.REACT_APP_GA_TOKEN) {
  // token is set in netlify.toml
  // https://stackoverflow.com/questions/52542840/can-i-use-build-environment-variables-in-netlify-with-create-react-app
  GoogleAnalytics.initialize(process.env.REACT_APP_GA_TOKEN)
}

// most of this code comes from https://github.com/react-ga/react-ga/wiki/React-Router-v4-withTracker
const withTracker = (WrappedComponent, options = {}) => {
  const trackPage = page => {
    GoogleAnalytics.set({ page, ...options })
    GoogleAnalytics.pageview(page)

    window.Intercom && window.Intercom('update', { last_request_at: parseInt((new Date()).getTime() / 1000) })

    var _hsq = window._hsq = window._hsq || []
    _hsq.push(['setPath', page])
    _hsq.push(['trackPageView'])
  }

  const HOC = class TrackerHOC extends Component {
    componentDidMount () {
      const page = this.props.location.pathname + this.props.location.search
      trackPage(page)
    }

    componentDidUpdate (prevProps) {
      const currentPage = prevProps.location.pathname + prevProps.location.search
      const nextPage = this.props.location.pathname + this.props.location.search

      if (currentPage !== nextPage) {
        trackPage(nextPage)
      }
    }

    render () {
      return <WrappedComponent {...this.props} />
    }
  }

  return HOC
}

export default withTracker
